import React, { useState, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";

import { useAuth } from "features/auth/AuthProvider";
import AppRouter from "./router";
import LoginPage from "features/auth/LoginPage/LoginPage";
import ConnectionErrorPage from "components/feedback/ConnectionErrorPage/ConnectionErrorPage";
import eventEmitter from "events/EventEmitter";
import { EVENT_TYPES } from "events/eventTypes";

function AuthenticatedApp() {
  const { token } = useAuth();
  const [connectionError, setConnectionError] = useState(null);

  useEffect(() => {
    const handler = (err) => setConnectionError(err);
    eventEmitter.on(EVENT_TYPES.CONNECTION_ERROR, handler);
    return () => eventEmitter.off(EVENT_TYPES.CONNECTION_ERROR, handler);
  }, []);

  if (connectionError) return <ConnectionErrorPage />;

  return (
    <Router>{token ? <AppRouter /> : <LoginPage />}</Router>
  );
}

export default function App() {
  return <AuthenticatedApp />;
}
